import { render, staticRenderFns } from "./LoyaltyProgramOptIn.vue?vue&type=template&id=479c798b"
import script from "./LoyaltyProgramOptIn.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramOptIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports